import {
  get,
  patchVendorsAxios,
  post,
  postImageAxios,
} from "helpers/api_helper"
import { put, takeEvery } from "redux-saga/effects"
import { getVendorConfig } from "store/actions"
import { getFormDataFromJSON, showToast } from "utils"
import {
  getInboxSetupFailed,
  getInboxSetupSuccess,
  getListScreenSetupFailed,
  getListScreenSetupSuccess,
  updateInboxSetupFailed,
  updateInboxSetupSuccess,
  updateListScreenSetupFailed,
  getListScreenSetup as getListScreenSetupAction,
} from "./actions"
import {
  GET_INBOX_SETUP,
  GET_LIST_SCREEN_SETUP,
  UPDATE_INBOX_SETUP,
  UPDATE_LIST_SCREEN_SETUP,
} from "./actionTypes"
import * as url from "helpers/url_helper"

function* getListScreenSetup({ payload: params }) {
  try {
    const response = yield get(`/vendor/${params.vendorId}/design/event-list`)
    yield put(getListScreenSetupSuccess(response))
  } catch (error) {
    yield put(getListScreenSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* getInboxSetup({ payload: params }) {
  try {
    const response = yield get("/event/-1/private-messages/setup")
    yield put(getInboxSetupSuccess(response))
  } catch (error) {
    yield put(getInboxSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateInboxSetup({ payload: params }) {
  try {
    const response = yield post("/event/-1/private-messages/setup", params)
    yield put(updateInboxSetupSuccess(params))
    showToast("success", "Inbox style updated!", "Success")
  } catch (error) {
    yield put(updateInboxSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateListScreenSetup({ payload: params }) {
  try {
    let header = null
    let background = null
    if (params?.uploadHeaderImage) {
      header = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params.headerImage)
      )
    }
    if (params?.uploadBackgroundImage) {
      background = yield postImageAxios(
        "/file",
        getFormDataFromJSON(params.bgImage)
      )
    }
    const response = yield post(
      `/admin/vendor/${params?.values?.vendor_id}/event_list`,
      {
        ...params.values,
        ...(header
          ? { image_file: header[0], delete_image: 1, image_url: null }
          : {}),
        ...(background
          ? {
              bg_image_file: background[0],
              delete_bg_image: 1,
              bg_image_url: null,
            }
          : {}),
      }
    )
    if (params?.clientSetup) {
      yield patchVendorsAxios(
        url.UPDATE_CLIENT_CONFIGS + params?.clientSetup?.vendor_id + "/config",
        params?.clientSetup
      )
      yield put(getVendorConfig({ id: params?.clientSetup?.vendor_id }))
    }
    yield put(getListScreenSetupAction({ vendorId: response?.vendor_id }))
    showToast("success", "List screen updated!", "Success")
  } catch (error) {
    yield put(updateListScreenSetupFailed(error))
    showToast("error", error, "Error")
  }
}

function* listScreenSaga() {
  yield takeEvery(GET_LIST_SCREEN_SETUP, getListScreenSetup)
  yield takeEvery(GET_INBOX_SETUP, getInboxSetup)
  yield takeEvery(UPDATE_INBOX_SETUP, updateInboxSetup)
  yield takeEvery(UPDATE_LIST_SCREEN_SETUP, updateListScreenSetup)
}

export default listScreenSaga
